import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';
import { FeedbackMessageText, TicketTextBold, TicketTextRegular } from '../../../common/fontElements';

export const ButtonHolder = styled.div`
  margin: 0px 20px 0;
`;

export const MessageWrapper = styled.div`
  cursor: auto;
  border-bottom: 0.1rem solid ${colors.lightGray15};
  color: ${colors.black4};
  white-space: pre-wrap;
  padding: 20px 0px;

  & em {
    background-color: #a1b6a7;
    color: #fff;
    font-style: normal;
  }
`;

export const MessageSubject = styled(TicketTextRegular)`
  white-space: normal;
  padding-bottom: 8px;
`;

export const MessageBody = styled(TicketTextRegular)`
  white-space: pre-wrap;
`;

export const MessageDetails = styled(TicketTextBold)`
  white-space: normal;
  padding-bottom: 8px;
`;

export const FeedbackWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

export const ResultFeedback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 15px;
  margin: 0;
  background-color: ${colors.lightGray7};
`;

export const FeedbackDescription = styled(FeedbackMessageText)`
  display: inline-block;
  margin: 0px 15px;
  color: ${colors.black4};
  line-height: 2em;
  ${(props) => (props.hide ? 'display: none;' : '')};
`;

export const FeedbackButtonsWrapper = styled.div`
  margin: 0px;
`;

export const ConversationWrapper = styled.div`
  width: calc(100% - 60px);
  text-align: left;
  border-spacing: 0;
  border-collapse: collapse;
  table-layout: fixed;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin: 0 30px 10px;
`;
